const getConstants = require('../../../utils/getConstants');
const { normalizeLongIdentity, selectPreferredSubmission } = require('./submissionSelection');

const { taskStates } = getConstants();

module.exports = function findResumableSubmissionForUser({ submissions, noUser }) {
   const normalizedUser = normalizeLongIdentity(noUser);
   if (!submissions || normalizedUser == null) return null;

   // Resume is ownership-sensitive: only this user's in-progress attempts are editable; View has separate, broader selection rules.
   const candidates = Object.entries(submissions)
      .filter(([key]) => key !== 'main')
      .map(([, submission]) => submission)
      .filter(Boolean)
      .filter((submission) => normalizeLongIdentity(submission.noUserStartedBy) === normalizedUser)
      .filter((submission) => ((submission.state || 0) & taskStates.BUSY) === taskStates.BUSY);

   return selectPreferredSubmission(candidates);
};
